import { useState } from "react";
import {
  Tooltip,
  Grid,
  FormControl,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { ToastMessage } from "../../../global/ToastMessage";
import { useDispatch } from "react-redux";
import {
  obtenerHotelesByIdPaqueteAction,
  altaHotelCatalogAction,
} from "./../../../ducks/hotelDuck";
import { altaHotelPaqueteAction } from "./../../../ducks/paqueteDuck";
import BackDrop from "./../../../global/BackDrop";
import useCatalogo from "../../../hooks/useCatalogos";
import { FPaquetesStyle } from "./styles";
const AltaHotel = (props) => {
  const { origen, IdPaquete = 0 } = props;
  const classes = FPaquetesStyle();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [nombre, setNombre] = useState("");
  const [isLoad, setIsload] = useState(false);
  const [servicios, setServicios] = useState([]);
  const catServicios = useCatalogo("Servicio");
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const handleClickOpen = () => {
    setOpen(true);
    LimpiarForm();
  };
  const handleClose = () => {
    setOpen(false);
    LimpiarForm();
  };
  const onGuardar = () => {
    setIsload(true);
    let payload = {
      IdOrigen: origen.IdCiudad,
      Descripcion: nombre,
    };
    dispatch(altaHotelCatalogAction(payload)).then((Response) => {
      switch (Response.status) {
        case 500:
          ToastMessage.fire({
            icon: "error",
            title: "Ha habido un problema de conexión con el servidor",
          });
          break;
        case 400:
          ToastMessage.fire({
            icon: "warning",
            title: "<strong>Atención</strong>",
            text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
          });
          break;
        default:
          let hotel = {
            IdPaquete: IdPaquete,
            IdHotel: Response.data,
            Servicio: getIdServicios(servicios),
          };
          dispatch(altaHotelPaqueteAction(hotel)).then((respueta) => {
            switch (respueta.status) {
              default:
                setOpen(false);
                setIsload(false);
                dispatch(obtenerHotelesByIdPaqueteAction(IdPaquete));
                ToastMessage.fire({
                  icon: "success",
                  title: "Exito en la operacion",
                });
                break;
            }
          });
          break;
      }
    });
  };
  const getIdServicios = (arrayTipo) => {
    return arrayTipo.map((item) => {
      return item.IdServicio;
    });
  };
  const LimpiarForm = () => {
    setNombre("");
    setServicios([]);
  };

  const getDescripcion = (arrayTipo) => {
    return arrayTipo.map((item) => {
      return item.Descripcion;
    });
  };

  const handleChange = (event) => {
    setServicios(event.target.value);
  };

  return (
    <div>
      <Tooltip title="Agregar hotel">
        <span>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClickOpen}
            disabled={origen.IdCiudad > 0 ? false : true}
          >
            <AddCircleOutlineIcon />
          </Button>
        </span>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Nuevo hotel</DialogTitle>
        <DialogContent>
          <DialogContentText>{origen.Nombre}</DialogContentText>
          <Grid container>
            <Grid item xs={12}>
              <TextField
                required
                id="input-Nombre"
                label="Nombre"
                type="text"
                variant="outlined"
                name="nombre"
                value={nombre}
                onChange={(event) => setNombre(event.target.value)}
                className={classes.textField}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-mutiple-checkbox-label">
                  Servicios
                </InputLabel>
                <Select
                  labelId="demo-mutiple-checkbox-label"
                  id="demo-mutiple-checkbox"
                  multiple
                  value={servicios}
                  onChange={handleChange}
                  input={<Select id="Select-multiple" />}
                  renderValue={(selected) =>
                    getDescripcion(selected).join(", ").toString()
                  }
                  MenuProps={MenuProps}
                >
                  {catServicios.map((item) => (
                    <MenuItem key={item.Descripcion} value={item}>
                      <Checkbox checked={servicios.indexOf(item) > -1} />
                      <ListItemText primary={item.Descripcion} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={onGuardar}
            color="primary"
            disabled={nombre.length > 0 ? false : true}
          >
            Agregar
          </Button>
        </DialogActions>
      </Dialog>
      <BackDrop open={isLoad} />
    </div>
  );
};
export default AltaHotel;
